/*
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

(function( $ ) {

/**
 * initMap
 *
 * Renders a Google Map onto the selected jQuery element.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @return  object The map instance.
 */
function initMap( $el ) {

    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create generic map.
    var mapArgs = {
        zoom        : $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP
    };

    var map = new google.maps.Map( $el[0], mapArgs );

    // Add markers.
    map.markers = [];

    $markers.each(function() {
        initMarker( $(this), map );
    });

    // Center map based on markers.
    centerMap( map );

    // Cluster markers.
    var clusterer = new markerClusterer.MarkerClusterer({
        map: map,
        markers: map.markers
    });

    // Show map once everything has loaded and settled.
    google.maps.event.addListenerOnce(map, 'idle', function() {
        $el.addClass('is-loaded');
    });

    // Return map instance.
    return map;
}


/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $marker The marker element.
 * @param   object map The map instance.
 * @return  object The marker instance.
 */
function initMarker( $marker, map ) {

    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');

    var latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
        position: latLng
    });

    // Append to reference for later use.
    map.markers.push( marker );

    // If marker contains HTML, add it to an infoWindow.
    if ( $marker.html() ) {

        // Create info window.
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open( map, marker );
        });
    }
}


/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object map The map instance.
 * @return  void
 */
function centerMap( map ) {

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();

    map.markers.forEach(function( marker ) {

        var position = marker.getPosition();

        bounds.extend( position );

    });

    // Case: Single marker.
    if ( map.markers.length === 1 ) {

        map.setCenter( bounds.getCenter() );

    // Case: Multiple markers.
    } else if ( map.markers.length > 1 ) {

        map.fitBounds( bounds );
    }
}


// Render maps on page load.
$(document).ready(function() {

    $('.google-map').each(function() {
        initMap( $(this) );
    });

});

})(jQuery);